import WizardPageLayout from './WizardPageLayout';

export default WizardPageLayout;
